import React from 'react';
import { Redirect } from 'react-router-dom';
import authRoles from 'app/auth/authRoles';

/**
 * Both lists live in the Admin Console's Automations tab now. The list routes stay
 * as redirects so every "back to the list" already written against them — the form
 * headers, the submissions header, the pushes after a save — lands on that tab
 * instead of a page that no longer exists.
 */
const AUTOMATIONS_TAB = '/settings/users?tab=automations';

const OnboardingSectionConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        }
      }
    }
  },
  routes: [
    {
      path: '/email-templates',
      exact: true,
      component: () => <Redirect to={AUTOMATIONS_TAB} />
    },
    {
      path: '/email-templates/new',
      auth: authRoles.marketing,
      component: React.lazy(() => import('../settings/templates/TemplateFormPage'))
    },
    {
      path: '/email-templates/edit/:id',
      auth: authRoles.marketing,
      component: React.lazy(() => import('../settings/templates/TemplateFormPage'))
    },
    {
      path: '/form-generator',
      exact: true,
      component: () => <Redirect to={AUTOMATIONS_TAB} />
    },
    {
      path: '/form-generator/new',
      auth: authRoles.marketing,
      component: React.lazy(() => import('../settings/form-generator/FormGeneratorFormPage'))
    },
    {
      path: '/form-generator/edit/:id',
      auth: authRoles.marketing,
      component: React.lazy(() => import('../settings/form-generator/FormGeneratorFormPage'))
    },
    {
      path: '/form-generator/:id/submissions',
      auth: authRoles.marketing,
      component: React.lazy(() => import('../settings/form-generator/FormSubmissionsPage'))
    }
  ]
};

export default OnboardingSectionConfig;
